import ndwi from './raw/ndwi.json';

export const ndwiColorMap = type => {
  if (type === 'range') {
    return ndwi;
  }
};
